// src/Theme.js
export const theme = {
    colors: {
      primary: '#018D66',
      cta: '#FFA41C',
      background: '#EAFEE5',
      text: '#292929',
      white: '#FFFFFF',
    },
    font: '"Merriweather Sans", "Open Sans", sans-serif',
  };
  